export default {
  'Submit': 'إرسال',
  'Save': 'حفظ',
  'enterOTP': 'أدخل رمز التحقق',
  'otpSent': 'تم إرسال رمز التحقق',
  'login/signup': 'الدخول أو التسجيل',
  'resendCode': 'إعادة إرسال الرمز',
  'edit': 'تعديل',
  'otpMessage': 'تم إرسال رمز مكون من 6 أرقام إلى رقم هاتفك المحمول',
  'oyo360WelcomeMessage': 'الدخول أو التسجيل',
  'oyo360ResendCode': 'إعادة إرسال الرمز',
  'oyo360Edit': 'تعديل',
  'oyo360otpMessage': 'تم إرسال رمز مكون من 6 أرقام إلى رقم هاتفك المحمول',
  'buttonActionContinue': 'متابعة',
  'chooseLanguage': 'اختر لغة',
  'currentLanguage': 'اللغة الحالية',
  'otherLanguages': 'لغات اخرى',
  'google': 'جوجل',
  'facebook': 'الفيسبوك',
  'or': 'أو',
  'buttonActionSubmit': 'إرسال',
  'signingIn': 'تسجيل الدخول',
  'invalidMobileNumber': 'رقم الجوال غير صالح',
  'welcomeTitle': 'مرحبًا بكم في اويو',
  'welcomeHeadingForMailLogin': 'أدخل البريد الإلكتروني المسجل المرتبط بنا',
  'welcomeHeadingForPhoneLogin': 'أدخل رقم الجوال المسجل المرتبط بنا',
  'emailIdLabel': 'البريد الإلكتروني',
  'phoneNumberLabel': 'رقم الهاتف',
  'passwordLabel': 'كلمه المرور',
  'newPasswordLabel': 'كلمة مرور جديدة',
  'confirmNewPasswordLabel': 'تأكيد كلمة المرور الجديدة',
  'emailErrorMessage': 'الرجاء إدخال بريد إلكتروني صحيح',
  'welcomeHeadingForLogin': 'أدخل البريد الإلكتروني أو رقم الجوال المسجل',
  'userNameLabel': 'البريد الإلكتروني أو رقم الجوال',
  'userNameErrorMessage':'الرجاء إدخال البريد الإلكتروني / رقم الجوال الصحيح',
  'phoneNumberErrorMessage': 'الرجاء إدخال رقم الجوال الصحيح',
  'passwordErrorMessage': 'الرجاء إدخال كلمة المرور الصحيحة',
  'confirmPasswordErrorMessage': 'كلمة المرور غير مطابقة!',
  'generateNewPassword': 'إنشاء كلمة مرور جديدة',
  'loginButtonLabel': 'تسجيل الدخول',
  'loginWithPhoneButtonLabel': 'المتابعة مع الهاتف',
  'loginWithOtp': ' تسجيل الدخول باستخدام رمز التحقق بدلاً من ذلك',
  'loginWithEmailButtonLabel': 'المتابعة مع البريد الإلكتروني',
  'back': 'العودة',
  'loginWithOtpTitle': 'أدخل رمز التحقق',
  'loginWithOtpHeading': 'ستتلقى كلمة المرور لمرة واحدة إذا كان رقم الهاتف مسجلاً في أنظمتنا',
  'listYourProperty': 'قائمة الممتلكات الخاصة بك',
  'listProperty': 'قائمة الممتلكات الخاصة بك',
  'privacyPolicy': 'سياسة الخصوصية',
  'termsOfUse': 'تعليمات الاستخدام',
  'privacyFooterText': 'من خلال تسجيل الدخول إلى حسابك ، فإنك تقبل شروط {termsOfUse} و{privacyPolicy} الخاصة بنا',
  'and': 'و',
  'verifyEmail': 'التحقق من البريد الإلكتروني',
  'verifyMobile': 'التحقق من رقم الجوالr',
  'forgotPasswordPhoneSubHeading': 'سنرسل لك رمزًا مكونًا من 6 أرقام للتحقق من رقم هاتفك',
  'forgotPasswordMailSubHeading': 'سنرسل لك رمزًا مكونًا من 6 أرقام للتحقق من البريد الإلكتروني الخاص بك',
  'newPasswordCondition1': 'يجب أن يحتوي على كل من الرقم والرمز',
  'newPasswordCondition2': 'يجب أن يحتوي على 8 أحرف على الأقل',
  'newPasswordCondition3': 'يجب أن تحتوي على أحرف صغيرة وكبيرة',
  'confirmLogin': 'التأكيد وتسجيل الدخول',
  'getOTP': 'احصل على رمز التحقق',
  'invalidInput': 'مدخل غير صالح',
  'passwordResetMessage': 'تم إنشاء كلمة المرور بنجاح',
  'otpErrorMessage': 'الرجاء إدخال رمز التحقق الصحيح',
  'resendOtpSuccessMessage': 'تم إعادة إرسال رمز التحقق إلى رقم جوالك بنجاح',
  'InternalServerErrorMessage': 'خطأ في الخادم الداخلي',
  'resetPasswordHeading': 'تم إرسال رمز مكون من 6 أرقام إلى بريدك الإلكتروني ورقم هاتفك',
  'whiteSpace': ' ',
  'errorNoAssociatedHotels':
    '\u0644\u064a\u0633 \u0644\u062f\u064a\u0643 \u0641\u0646\u0627\u062f\u0642 \u0645\u0631\u062a\u0628\u0637\u0629',
  'facingIssue': 'Facing any issue? ',
  'oldLoginViewSwitch': 'Switch to Old view',
  'passwordChangeInformationText': 'سيتم تسجيل خروجك من جميع الأجهزة بعد تغيير كلمة المرور الخاصة بك'
};
